import ROUTES from "../constants/Routes";
import LoginContainer from "../pages/auth/login/LoginContainer";
import ForgotPasswordContainer from "../pages/auth/forgot_password/ForgotPasswordContainer";
import ConfirmationContainer from "../pages/auth/forgot_password/ConfirmationContainer";
import ResetPasswordContainer from "../pages/auth/reset_password/ResetPasswordContainer";
import ResetConfirmationContainer from "../pages/auth/reset_password/ResetConfirmationContainer";
import { RedirectLoginContainer } from "../pages/auth/login/RedirectLoginContainer";

const AuthRouter = [{
  route: ROUTES.LOGIN_SCREEN,
  element: <LoginContainer />,
},
{
  route: ROUTES.FORGOT_PASSWORD_SCREEN,
  element: <ForgotPasswordContainer />,
},
{
  route: ROUTES.CONFIRMATION_SCREEN,
  element: <ConfirmationContainer />
},
{
  route: ROUTES.RESET_PASSWORD_SCREEN,
  element: <ResetPasswordContainer />
},
{
  route: ROUTES.RESET_CONFIRMATION_SCREEN,
  element: <ResetConfirmationContainer />
},
{
  route: ROUTES.REDIRECT_LOGIN,
  element: <RedirectLoginContainer />
}
];

export default AuthRouter;
